import { cva } from 'class-variance-authority'

/*
 * Ported from `.categorybadgewrapper` + `.categorybadgetext`, which the Webflow
 * build always uses as a pair. Merged into one element here — the outer div
 * existed only to carry the border.
 */
export const badgeVariants = cva(
  'inline-block rounded border border-solid leading-[14px] font-medium eyebrow',
  {
    variants: {
      variant: {
        default: 'border-grayscale-200 px-2 py-1.5 text-font-secondary',
        /** .is-active */
        active: 'border-grayscale-200 bg-violet-900 px-2 py-1.5 text-white',
        /** .top-filter — pill, borderless */
        filter: 'rounded-pill border-none px-4 py-1.5 text-font-secondary hover:bg-card-bg',
        /** .top-filter.is-active */
        filterActive: 'rounded-pill border-none bg-font-default px-4 py-1.5 text-white',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)
